import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getVideoProgress } from 'api/Video';

export const useVideoProgress = ({ params = {}, options = {}, dependencies = [] } = {}) => {
  const navigate = useNavigate();

  const { video_id, file_name } = params;

  return useQuery({
    queryKey: ['video-progress', video_id, file_name, ...dependencies],
    queryFn: () => getVideoProgress(navigate, params),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    ...options
  });
};
